import api from '../../plugins/api';

const deleteModel = (params) => {
  return api.post('/api/crm/cars/deleteModel', params);
};

export default deleteModel;
